/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const TrashIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <rect x="4.27272727" y="4.20833333" width="14.5454545" height="18.3333333" />
      <rect x="7.90909091" y="1.45833333" width="7.27272727" height="2.75" />
      <path d="M2,4.20833333 L22,4.20833333" />
      <path d="M7.90909091,7.41666667 L7.90909091,18.4166667" />
      <path d="M11.5454545,7.41666667 L11.5454545,18.4166667" />
      <path d="M15.1818182,7.41666667 L15.1818182,18.4166667" />
    </g>
  </svg>
);

export default TrashIcon;
